// share.jsx
export const handleShare = async () => {
  if (navigator.share) {
    try {
      await navigator.share({
        title: "PraSha Sync",
        text: "Your Personalized Mental Healthcare Companion",
        url: "https://care.prashasync.io",
      });
      console.log("Shared successfully!");
    } catch (error) {
      console.error("Error sharing:", error);
    }
  } else {
    // Fallback: WhatsApp Web with text + link
    window.open(
      "https://wa.me/?text=" +
        encodeURIComponent(
          "PraSha Sync - Your Personalized Mental Healthcare Companion\nhttps://care.prashasync.io"
        ),
      "_blank"
    );
  }
};
